/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

/*------------------------------------*\
    SIDE NAV
\*------------------------------------*/
class SideNav {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
    }

    init() {
        let self = this;

        var nav = document.getElementById('sideNav');
        var toggle = document.getElementById('sideNavToggle');

        toggle.addEventListener('click', function(event) {
            nav.classList.toggle('closed');
        });

        self.scroll();
    }

    scroll() {
        let self = this;

        var x = document.getElementsByClassName('side-nav__list__item');

        $(document).scroll(function(){
            for (let i of x) {
                if (i.hash) {
                    self.getPosition(i.hash);
                }
            }
        });
    }

    getPosition(e) {
        let self = this;

        var i = $(e).position();

        self.checkItem(i, e);
    }

    checkItem(i, e) {
        let self = this;

        var id = e.substring(1);
        var el = document.getElementById(id);
        var vp = self.elementInViewport(el);

        if (vp == true) {
            $('a[href="'+e+'"]').addClass('active');
        } else {
            $('a[href="'+e+'"]').removeClass('active');
        }
    }

    elementInViewport(el) {
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;

        while(el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
            top < (window.pageYOffset + window.innerHeight) &&
            left < (window.pageXOffset + window.innerWidth) &&
            (top + height) > window.pageYOffset &&
            (left + width) > window.pageXOffset
        );
    }
}

export default SideNav;
